import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { HecResponse } from '../../../../shared/shared-interfaces/hecResponse';
import { SharedService } from '../../../../shared/sharedServices/shared.service';
import { HEC_CONSTANTS } from '../../../../utilities/constants';
import { DocumentViewerComponent } from '../document-viewer/document-viewer.component';
import { PdfViewerComponent } from '../pdf-viewer/pdf-viewer.component';

@Component({
  selector: 'kt-document-list',
  templateUrl: './document-list.component.html',
  styleUrls: ['./document-list.component.css']
})
export class DocumentListComponent implements OnInit {
  public loader:boolean;
  @Input('optionalDocumentList')optionalDocumentList;
  public optionalLoader:any= [];
  @Input('formView')formView;
  @Input('acronym')acronym;
  public viewTypes:any = HEC_CONSTANTS.FORM_VIEW_TYPES;
  public documentClickedTypes:any = HEC_CONSTANTS.DOCUMENT_CLICKED_TYPE
  constructor(private sharedService:SharedService, private matDialog: MatDialog,) { }

  ngOnInit() {
    console.log(this.viewTypes.VIEW)
    console.log(this.formView)
  }

  public deleteUploadDoc(id,index,type,acronym,eduDocIndex?){
    this.optionalLoader[index] = true;
    let payload = {
      data: {
          documentId: id,
          acronym:acronym
      }
    }
    this.sharedService.deleteDocument(payload).subscribe(
      (res:HecResponse)=>{
          this.optionalLoader[index] = false;
        if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
           this.optionalDocumentList.splice(index,1)
          }            
      }
    )
  }

  //git change

  public downloadDocument(file,acronym,index,reqType,downloadType){
    console.log(file)
    this.optionalLoader[index] = true;
    if(file.docId){
    let payload = {
      data: {
          documentId: file.docId,
          acronym: acronym
      }
    }
    this.sharedService.getAttachmentByDocumentId(payload).subscribe(
      (res:HecResponse)=>{
            this.optionalLoader[index]=false;
        if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
          if(downloadType == this.documentClickedTypes.VIEW){
            if (res.data.path.toLowerCase().split('.').pop() != 'pdf') {
              this.ModalComponent(DocumentViewerComponent, res.data.path.toLowerCase().split('.').pop(), res.data.content, 'landingpage-popup-two', 'landingpage-popup-inner-two')
            } else {
              this.ModalComponent(PdfViewerComponent, res.data.path.toLowerCase().split('.').pop(), res.data.content, 'landingpage-popup-two', 'landingpage-popup-inner-three')
            }
          }else{
            this.sharedService.saveFile(res.data.content,file,res.data.path.toLowerCase().split('.').pop())
          }
        }
      }
    )
  }
  }

  public ModalComponent(component, imageType, imageContent, backdropClass?, panelClass?) {
    const dialogRef = this.matDialog.open(component, {
      width: '70vw',
      height: '60vh',
      backdropClass: backdropClass,
      panelClass: panelClass,
      disableClose: true,
      autoFocus: false,
      data: { imageType: imageType, imageContent: imageContent }
    });
  }

}
